import { Form, Row, Col, Button, InputGroup } from 'react-bootstrap'
import { useState, useEffect } from 'react'
import { Request } from '@group-devs/yfp7-global-modules'
import Alert from '@group-devs/yfp7-global-modules/components/Alert'

const request = new Request(process.env.apiDomain)

function otherDetails(props) {

    let contactAccount = props.contactAccount
    let instagram_metadata = contactAccount && contactAccount.contact.socialSpace ? JSON.parse(JSON.parse(contactAccount.contact.socialSpace.instagram_metadata)) : {}

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [key, setKey] = useState(0);

    const [showUpdate, setShowUpdate] = useState(false);
    const [readOnly, setReadOnly] = useState(true);
    const [contactId, setContactId] = useState(null);
    const [data, setData] = useState({
        linkedin: null,
        pinterest: null,
        twitter: null,
        instagram_metadata: null
    })

    useEffect(() => {
        if(typeof contactAccount != 'undefined'){
            setData({ 
                linkedin: contactAccount && contactAccount.contact.socialSpace ? contactAccount.contact.socialSpace.linkedin : "",
                pinterest: contactAccount && contactAccount.contact.socialSpace ? contactAccount.contact.socialSpace.pinterest : "",
                twitter: contactAccount  && contactAccount.contact.socialSpace ? contactAccount.contact.socialSpace.twitter : "",
                instagram_metadata: instagram_metadata ? instagram_metadata.url : "",
            })

            setContactId(contactAccount.contact_id)
        }
    }, [contactAccount]);

    const onClickEdit = () => {
        setShowUpdate(!showUpdate)
        setReadOnly(false)
    }

    const onClickCancel = () => {
        setShowUpdate(!showUpdate)
        setReadOnly(true)
    }

    function handleChange(evt)
    {
        const value = evt.target.value;
        setData({
          ...data,
          [evt.target.name]: value
        });
    }

    async function handleSave(e)
    {
        let res = await request.contacts.updateSocialSpaces({...data, contact_id: contactId});
        if(res.err){
            console.log('error')
        }else{
            onSuccess('Successfully updated other details.')
            onClickCancel()
        }
    }

    const onSuccess = (message) => 
    {
        setSuccessMessage(message)
        setErrorMessage(''); // Clear error message if any
        setKey(prevKey => prevKey + 1); // Change key to force re-render
    }

    return (
        <div className="OtherSocialDetails py-5">
            <Row>
                <Col xl={{span:10, offset:1}}>
                    <Alert key={key} successMessage={successMessage} errorMessage={errorMessage}/>
                    <p><strong>Others</strong></p>
                    <Form>
                        <Form.Group as={Row} controlId="formPlaintextLinkedIn">
                            <Form.Label column md="3" className="text-md-right">LinkedIn</Form.Label>
                            <Col md="7">
                                {/* <Form.Control type="text" className="rounded-0" defaultValue={contactAccount ? contactAccount.contact.socialSpace.linkedin : ""} readOnly={readOnly}/> */}
                                <InputGroup className="mb-3">
                                    <InputGroup.Text id="basic-linkedin" className="input-group-no-right-radius">linkedin.com/</InputGroup.Text>
                                    <Form.Control aria-describedby="basic-linkedin" name="linkedin" onChange={handleChange} value={data.linkedin} readOnly={readOnly}/>
                                </InputGroup>
                            </Col>
                        </Form.Group>
                        {/* <Form.Group as={Row} controlId="formPlaintextYoutube">
                            <Form.Label column md="3" className="text-md-right">Youtube</Form.Label>
                            <Col md="7">
                                <Form.Control type="text" className="rounded-0" defaultValue="https://www.youtube.com/sampleprofile"/>
                            </Col>
                        </Form.Group> */}
                        <Form.Group as={Row} controlId="formPlaintextPinterest">
                            <Form.Label column md="3" className="text-md-right">Pinterest</Form.Label>
                            <Col md="7">
                                {/* <Form.Control type="text" className="rounded-0" defaultValue={contactAccount ? contactAccount.contact.socialSpace.pinterest : ""} readOnly={readOnly}/> */}
                                <InputGroup className="mb-3">
                                    <InputGroup.Text id="basic-pinterest" className="input-group-no-right-radius">pinterest.com/</InputGroup.Text>
                                    <Form.Control aria-describedby="basic-pinterest" name="pinterest" onChange={handleChange} value={data.pinterest} readOnly={readOnly}/>
                                </InputGroup>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextTwitter">
                            <Form.Label column md="3" className="text-md-right">Twitter</Form.Label>
                            <Col md="7">
                                {/* <Form.Control type="text" className="rounded-0" defaultValue={contactAccount ? contactAccount.contact.socialSpace.twitter : ""} readOnly={readOnly}/> */}
                                <InputGroup className="mb-3">
                                    <InputGroup.Text id="basic-twit" className="input-group-no-right-radius">twitter.com/</InputGroup.Text>
                                    <Form.Control aria-describedby="basic-twit" name="twitter" onChange={handleChange} value={data.twitter} readOnly={readOnly}/>
                                </InputGroup>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextTwitter">
                            <Form.Label column md="3" className="text-md-right">Instagram</Form.Label>
                            <Col md="7">
                                {/* <Form.Control type="text" className="rounded-0" defaultValue={contactAccount ? contactAccount.contact.socialSpace.twitter : ""} readOnly={readOnly}/> */}
                                <InputGroup className="mb-3">
                                    <InputGroup.Text id="basic-twit" className="input-group-no-right-radius">instagram.com/</InputGroup.Text>
                                    <Form.Control aria-describedby="basic-twit" name="instagram_metadata" onChange={handleChange} value={data.instagram_metadata} readOnly={readOnly}/>
                                </InputGroup>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formPlaintextSlideShare">
                            {/* <Form.Label column md="3" className="text-md-right">SlideShare</Form.Label> */}
                            <Col md="3"></Col>
                            <Col md="7">
                                {/* <Form.Control type="text" className="rounded-0 mb-4" defaultValue="https://www.slideshare.net/sampleprofile"/> */}
                                {!showUpdate && <Button onClick={onClickEdit} className="px-5 py-2 mb-2 btn btn-success rounded-pill"><strong>Edit</strong></Button>}
                                {showUpdate && 
                                    <>
                                        <Button className="px-5 py-2 mr-2 mb-2 btn btn-success rounded-pill" onClick={handleSave}><strong>Save</strong></Button> 
                                        <Button onClick={onClickCancel} className="px-5 py-2 mb-2 btn btn-secondary rounded-pill"><strong>Cancel</strong></Button> 
                                    </>
                                }                        
                            </Col>
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default otherDetails;
